import { render, staticRenderFns } from "./automatic.vue?vue&type=template&id=08f68fd2&scoped=true&"
import script from "./automatic.vue?vue&type=script&lang=js&"
export * from "./automatic.vue?vue&type=script&lang=js&"
import style0 from "./automatic.vue?vue&type=style&index=0&id=08f68fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f68fd2",
  null
  
)

export default component.exports